import React from "react";
import { Paper, Typography, Box } from "@mui/material";
import dayjs from "dayjs";

const OrderFulfillmentInfo = ({ fulfillment }) => (
  <Paper
    variant="outlined"
    sx={{ p: 3, minHeight: 150 }}
    className="print-section">
    <Typography
      variant="subtitle1"
      fontWeight="bold"
      gutterBottom
      sx={{ mb: 2 }}>
      Fulfillment Details
    </Typography>

    {/* Fulfillment Method as plain text */}
    <Box mb={0.5}>
      <Typography variant="body2" fontWeight="bold">
        {fulfillment.method === "delivery" ? "Delivery" : "Pickup"}
      </Typography>
    </Box>

    {/* Date and Time */}
    <Box mb={0.5}>
      <Typography variant="body2">
        {dayjs(fulfillment.date).format("dddd, MMMM D")} at {fulfillment.time}
      </Typography>
    </Box>

    {/* Location */}
    <Typography variant="body2">{fulfillment.location}</Typography>
  </Paper>
);

export default OrderFulfillmentInfo;
